import {
    FETCH_ADMINS_SUCCESSFUL,
    FETCH_CLIENT_USERS, FETCH_CLIENT_USERS_FAILED,
    FETCH_CLIENT_USERS_SUCCESSFUL,
    FETCH_SYSTEM_INFO_SUCCESSFUL
} from "../actions/Types";

const INITIAL_STATE = {
    admins: [],
    systemInfo: {},
    clientUsers: [],
    clientUsersLoading: false
};

const AppReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case FETCH_ADMINS_SUCCESSFUL:
            return { ...state, admins: action.payload };
        case FETCH_SYSTEM_INFO_SUCCESSFUL:
            return { ...state, systemInfo: action.payload };

        case FETCH_CLIENT_USERS:
            return { ...state, clientUsersLoading: true };
        case FETCH_CLIENT_USERS_SUCCESSFUL:
            return { ...state, clientUsersLoading: false, clientUsers: action.payload };
        case FETCH_CLIENT_USERS_FAILED:
            return { ...state, clientUsersLoading: false };
        default:
            return state;
    }
};

export default AppReducer;